import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountLayoutComponent } from './layout/account-layout.component';
import { RouterModule } from '@angular/router';

const ACCOUNT_ROUTES = [
  {
    path: '',
    component: AccountLayoutComponent,
    loadChildren: () => import('./account.module').then((m) => m.AccountModule),
  },
];

@NgModule({
  declarations: [AccountLayoutComponent],
  imports: [CommonModule, RouterModule.forChild(ACCOUNT_ROUTES)],
})
export class AccountLayoutModule {}
